const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://abc.yooinno.com';

export const API_ENDPOINTS = {
  ENROLL: `${API_BASE_URL}/api/v1/enroll`,
  // Add other endpoints here
};